import {Accordion, AccordionDetails, AccordionSummary, Grid, InputAdornment, Typography, useTheme} from "@mui/material";
import {FormAutocomplete, FormCustomSwitch, FormTextField} from "../../../../common/form-fields";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import {FormRateModel, RateSelectFE} from "../../../../api/types/rate";
import {useRecoilState} from "recoil";
import {rateAccordionExpandedState} from "../../../../state/ratesRecoil";
import {ExpandMore} from "@mui/icons-material";
import {FormElementI} from "../../../../api/types/generic";
import {useFormContext} from "react-hook-form";
import {i18nConvertNumberWithDecimals, setFormNumberValue} from "../../../../utils";
import {numberIntegerWithNegativeValuesRegex, numberWithNegativeValuesRegex} from "../../../../constants";

const ReferenceTariffComponent = ({
                                      enable,
                                      rate,
                                      discountIncreasePercentage,
                                      discountIncreaseFixed
                                  }: {
    enable: FormElementI<boolean>
    rate: FormElementI<RateSelectFE>
    discountIncreasePercentage: FormElementI<string>
    discountIncreaseFixed: FormElementI<string>
}) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Theme
    const theme = useTheme();

    // Use Form Context
    const {setValue, formState: {isSubmitting, errors}, watch, register, getValues} = useFormContext<FormRateModel>();
    const watchAllValues = watch();

    // Use Recoil
    const [referenceTariffExpanded, setReferenceTariffExpanded] = useRecoilState(rateAccordionExpandedState("referenceTariff"));

    // // Use State
    // const [ discountIncreaseSelected, setDiscountIncreaseSelected ] = useState<string>("discountIncreasePercentage");
    //
    // useEffect(() => {
    //     if (getValues().referenceTariff.discountIncreaseSelected)
    //         setDiscountIncreaseSelected( getValues().referenceTariff.discountIncreaseSelected);
    // }, [getValues().referenceTariff.discountIncreaseSelected]);

    // const [ radioButtonOptions ] = useState<{ id: string, label: string }[]>([ {
    //     id: "discountIncreasePercentage",
    //     label: `${ t("pricing:rate.form.labels.referenceTariffLabels.discountIncreasePercentage") }`
    // }, {
    //     id: "discountIncreaseFixed",
    //     label: `${ t("pricing:rate.form.labels.referenceTariffLabels.discountIncreaseFixed") }`
    // } ]);

    useEffect(() => {
        if (!isSubmitting && errors.referenceTariff) {
            setReferenceTariffExpanded(true);
        }
        // eslint-disable-next-line
    }, [isSubmitting]);

    // const handleChangeRadioGroup = (e: any, value: string) => {
    //     setValue("referenceTariff.discountIncreaseSelected", value);
    //     setDiscountIncreaseSelected(value);
    //     if (value === "discountIncreasePercentage") {
    //         setValue("referenceTariff.discountIncreaseFixed", null);
    //     } else {
    //         setValue("referenceTariff.discountIncreasePercentage", null);
    //     }
    // };

    return (
        <Accordion expanded={referenceTariffExpanded}
                   onChange={(e, expanded) => setReferenceTariffExpanded(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Typography sx={{color: theme.palette.primary.dark}}>
                    {t("pricing:rate.form.labels.referenceTariff")}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                {/* REFERENCE TARIFF */}
                <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12} md={6} sx={{display: "flex", alignItems: "flex-end"}}>
                        {/* DISABLE / ENABLE */}
                        <FormCustomSwitch
                            {...register("referenceTariff.enable")}
                            label={`${t("pricing:rate.form.labels.referenceTariffLabels.enable")}`}
                            readOnly={enable.readonly}
                            handleChange={enable.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* RATE */}
                        <FormAutocomplete
                            {...register("referenceTariff.rate")}
                            label={`${t("pricing:rate.form.labels.referenceTariffLabels.rate")}`}
                            readOnly={rate.readonly}
                            options={rate.options || []}
                            handleChange={rate.handleChange as Function}
                            isOptionEqualToValue={(option, value) => option.code === value.code}
                        />
                    </Grid>
                    {/*<Grid item xs={ 12 } md={ 12 } sx={ { display: "flex", alignItems: "flex-end" } }>*/}
                    {/*  <RadioGroupComponent*/}
                    {/*      { ...register("referenceTariff.discountIncreaseSelected") }*/}
                    {/*      value={ discountIncreaseSelected }*/}
                    {/*      handleChange={ handleChangeRadioGroup }*/}
                    {/*      options={ radioButtonOptions }*/}
                    {/*      disabled={ !(watchAllValues.referenceTariff?.rate && watchAllValues.referenceTariff?.enable) || enable.readonly || isSubmitting }*/}
                    {/*  />*/}
                    {/*</Grid>*/}
                    <Grid item xs={12} md={6}>
                        {/* DISCOUNT INCREASE PERCENTAGE */}
                        <FormTextField
                            {...register("referenceTariff.discountIncreasePercentage")}
                            label={`${t("pricing:rate.form.labels.referenceTariffLabels.discountIncreasePercentage")}`}
                            readOnly={!(watchAllValues.referenceTariff?.rate && watchAllValues.referenceTariff?.enable) || discountIncreasePercentage.readonly}
                            type={"text"}
                            handleChange={(value: string) => setFormNumberValue(value, setValue, "referenceTariff.discountIncreasePercentage", numberIntegerWithNegativeValuesRegex)}
                            startAdornment={<InputAdornment position="start">%</InputAdornment>}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* DISCOUNT INCREASE FIXED */}
                        <FormTextField
                            {...register("referenceTariff.discountIncreaseFixed")}
                            label={`${t("pricing:rate.form.labels.referenceTariffLabels.discountIncreaseFixed")}`}
                            readOnly={!(watchAllValues.referenceTariff?.rate && watchAllValues.referenceTariff?.enable) || discountIncreaseFixed.readonly}
                            type={"text"}
                            handleChange={(value: string) => setFormNumberValue(i18nConvertNumberWithDecimals(value), setValue, "referenceTariff.discountIncreaseFixed", numberWithNegativeValuesRegex)}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default ReferenceTariffComponent;